import type { Highlight, Highlights } from '../../interface/Highlight';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';

export const useGetHighlights = () =>
  useQuery({
    queryKey: ['cross-sell', 'highlights'],
    queryFn: getHighlights,
  });

const getHighlights = async (): Promise<Highlight[]> => {
  const params = {
    keep_watch_contents_limit: 3,
  };

  const authToken = getCookie(authKeys.authToken);
  const urlFetchHighlights = authToken
    ? apiConfig.routes.crossSell.highlights
    : apiConfig.routes.crossSell.highlightsPublic;

  const { data } = await api.get<Highlights>(urlFetchHighlights, {
    params,
  });

  return data.items;
};
